import { Image as ImageIcon } from '@abbott-components/icons';
import { Stack, Divider } from '@mui/material';
import { InputField as InputFieldIcon } from '../icons/InputField';
import AddControlDate from '../Controls/Date/AddControlDate';
import AddControlNumeric from '../Controls/Numeric/AddControlNumeric';
import AddControlText from '../Controls/Text/AddControlText';
import AddControlImage from '../Controls/Image/AddNewImage';
import AddNewControlReadOnlyText from '../Controls/ReadOnlyText/AddNewControlReadOnlyText';
import AddNewPage from '../Controls/Page/AddNewPage';
import AddNewSignature from '../Controls/Signature/AddNewSignature';
import AddControlAttachment from '../Controls/Attachment/AddNewAttachment';
import ControlOptionsSubmenu from '../Controls/ControlOptionsSubmenu';
import List from '@mui/material/List';
import Paper from '@mui/material/Paper';
import { useState } from 'react';
import AddControlSelect from '../Controls/Select/AddControlSelect';
import AddControlFormula from '../Controls/CalculatedValue/AddControlCalculatedValue';
import AddControlTime from '../Controls/Time/AddControlTime';

export default ({ isReadOnlyView }: { isReadOnlyView: boolean }) => {
    const [isTextSelectionMenuOpen, setIsTextSelectionMenuOpen] =
        useState<boolean>(false);
    const [isUploadSelectionMenuOpen, setIsUploadSelectionMenuOpen] =
        useState<boolean>(false);

    const closeSubmenus = () => {
        setIsTextSelectionMenuOpen(false);
        setIsUploadSelectionMenuOpen(false);
    };

    const TextSelectionMenu = () => (
            <ControlOptionsSubmenu
                sx={{ top: '43%' }}
                icon={<InputFieldIcon />}
                onClick={() => {
                    closeSubmenus();
                    setIsTextSelectionMenuOpen(true);
                }}
                onMouseLeave={closeSubmenus}
                open={isTextSelectionMenuOpen}
                toolTipTitle='Input Fields'
            >
                <AddControlText />
                <AddControlNumeric />
                <AddControlDate />
                <AddControlTime />
            </ControlOptionsSubmenu>
    );

    const UploadSelectionMenu = () => (
            <ControlOptionsSubmenu
                sx={{ top: '42%' }}
                icon={<ImageIcon />}
                onClick={() => {
                    closeSubmenus();
                    setIsUploadSelectionMenuOpen(true);
                }}
                onMouseLeave={closeSubmenus}
                open={isUploadSelectionMenuOpen}
                toolTipTitle='Upload Image/Attachment'
            >
                <AddControlImage />
                <AddControlAttachment />
            </ControlOptionsSubmenu>
    );

    const controlOptions = [
        { icon: <AddNewPage /> },
        { icon: <Divider /> },
        { icon: <TextSelectionMenu /> },
        { icon: <UploadSelectionMenu /> },
        { icon: <AddNewControlReadOnlyText /> },
        { icon: <AddControlSelect /> },
        { icon: <AddControlFormula /> },
        { icon: <AddNewSignature /> }
    ];

    const listStyles = {
        bgcolor: 'background.paper',
        position: 'fixed',
        top: '50%',
        left: 0,
        transform: 'translate(0, -50%)',
        display: isReadOnlyView ? 'none' : 'block',
        zIndex: 999
    };

    return (
        <List sx={listStyles} component="nav">
            <Paper elevation={1}>
                {controlOptions.map(({ icon }, index) => (
                    <Stack key={index}>{icon}</Stack>
                ))}
            </Paper>
        </List>
    );
};
